import $ from 'jquery';

const accordionContent = $('.accordion__content');
const accordionItem = $('.accordion-item');
const accordionHeader = $('.accordion-header');

accordionHeader.on('click', function () {
    accordionItem.eq(accordionHeader.index(this)).addClass('accordion--active')
    accordionItem.each(function () {
        if ( $( this ).find('.collapsed').length !== 0 ) {
            $( this ).removeClass('accordion--active')
        }
    })
})
